/**
 * stripeConfirmRouting.js — Routage du confirm Stripe après `stripe.confirmPayment`.
 *
 * Contexte (§46 — bug critique câblage panier, régression c6b592f1) :
 *   `checkoutForm.jsx` est PARTAGÉ entre le flux MONO-article (BuyFlow → stripeModal) et le
 *   flux PANIER (CartCheckoutModal). Les deux flux ont des PaymentIntents avec des metadata
 *   différentes et des endpoints de confirmation différents :
 *     - MONO  : metadata = { tileId|tileGroupId, type, ... } → POST /transaction/confirm-stripe-payment
 *               (le composant appelle ce confirm legacy EN INTERNE avant onSuccess)
 *     - PANIER : metadata = { cartOrderId, cartOrderToken, expectedAmountCents, itemCount, userId }
 *               (PAS de tileId/type) → POST /cart/confirm-stripe-payment, déclenché par le parent
 *               via onSuccess. Appeler le confirm legacy interne sur un PI panier → 500.
 *
 * Cette fonction PURE décide si le composant doit DÉLÉGUER au parent (`onSuccess`) au lieu
 * d'appeler le confirm legacy interne.
 *
 * Détection :
 *   - explicite (préféré) : prop `cartMode === true` passée par CartCheckoutModal.
 *   - défensive (fallback) : la metadata du PaymentIntent retourné par Stripe contient `cartOrderId`.
 *
 * @param {Object}  args
 * @param {boolean} [args.cartMode]               Prop explicite (CartCheckoutModal).
 * @param {Object}  [args.paymentIntentMetadata]  PaymentIntent.metadata renvoyé par stripe.confirmPayment.
 * @returns {boolean} true → déléguer à onSuccess (NE PAS appeler le confirm legacy interne).
 */
export function isCartCheckout({ cartMode, paymentIntentMetadata } = {}) {
  if (cartMode === true) return true;
  if (
    paymentIntentMetadata &&
    typeof paymentIntentMetadata === 'object' &&
    paymentIntentMetadata.cartOrderId != null &&
    paymentIntentMetadata.cartOrderId !== ''
  ) {
    return true;
  }
  return false;
}

export default isCartCheckout;
